// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
 // api: "https://dev.vecport.net/api/vectron-crm/public/api/",
  api: "https://api.vecport.net/vectron-crm/public/api/",
  stripeTestApiKey: "pk_test_JISjl8FiwYJFzyDNYS5wRpvM",
  stripeApiKey: "pk_live_qjpJ2qj4kpQkeuVHkGOr0uTq",
  mobilePatterns: {
    AU: { pattern: '^(04|614|05|615)[0-9]{8,10}$', minimum: 9, maximum: 10 },
    NZ: { pattern: '^(02|2)[0-9]{6,10}$', minimum: 8, maximum: 11 },
    US: { pattern: '[0-9]{10}$', minimum: 10, maximum: 10 },
    UK: { pattern: '^(07)[0-9]{9}$', minimum: 11, maximum: 11 },
  }
};
